import React from 'react';
import {Route, Switch} from 'react-router-dom';

import HomePage from '../components/Home/HomePage';
import * as RoutePaths from '../constants/RoutePaths';
import SearchPage from '../components/Search/SearchPage';
import PropertyPage from '../components/PropertyPage/PropertyPage';
import CreateEditPropertyPage from '../components/CreatingProperty/CreateEditPropertyPage';

import CancellationPage from '../components/AgreementCancellation/CancellationPage';
import AgreementPage from '../components/Agreement/AgreementPage';
import ContactsPage from '../components/Contacts/ContactsPage';
import HelpPage from '../components/Help/HelpPage';
import ServicePage from '../components/Service/ServicePage';
import NotFoundPage from '../components/NotFoundPage';
import ReservationCompletePage from '../components/ReservationCompletePage';
import PrivacyPolicyPage from '../components/PrivacyPolicyPage';
import {AirbnbGetAppToken} from '../components/Airbnb/AirbnbGetAppToken';

export default () => {
    return (
        <Switch>
            <Route path={RoutePaths.HOME} exact component={HomePage}/>
            <Route path={RoutePaths.AIRBNB} exact component={AirbnbGetAppToken}/>
            <Route path={RoutePaths.SEARCH} exact component={SearchPage}/>
            <Route path={RoutePaths.PROPERTY_PAGE_OLD} exact component={PropertyPage}/>
            <Route path={RoutePaths.PROPERTY_PAGE} exact component={PropertyPage}/>
            <Route path={RoutePaths.CREATING_OBJECT} exact component={CreateEditPropertyPage}/>

            <Route path={RoutePaths.AGREEMENT} exact component={AgreementPage}/>
            <Route path={RoutePaths.PRIVACY} exact component={PrivacyPolicyPage}/>
            <Route path={RoutePaths.AGREEMENT_CANCELLATION} exact component={CancellationPage}/>
            <Route path={RoutePaths.CONTACTS} exact component={ContactsPage}/>
            <Route path={RoutePaths.HELP} exact component={HelpPage}/>
            <Route path={RoutePaths.SERVICE+'/:id'} component={ServicePage}/>
            <Route path={RoutePaths.RESERVATION_COMPLETE_PAGE+'/:id'} component={ReservationCompletePage}/>
            <Route component={NotFoundPage} />
        </Switch>
    );
};



// WEBPACK FOOTER //
// ./src/routes/index.js